
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Vendors
import moment from "moment";

// Models
import {AppAdministratorTrainingsRootListIndex} from "@/models/app/administrator/trainings/root/list/index";
import {AppCommonUser} from "@/models/app/common/User";
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppAdministratorTrainingsRootListFormCreateIndexVue from "@/views/app/administrator/trainings/root/list/form/create.vue";
import AppAdministratorTrainingsRootListFormUpdateIndexVue from "@/views/app/administrator/trainings/root/list/form/update.vue";
import AppAdministratorTrainingsRootListFormRemoveIndexVue from "@/views/app/administrator/trainings/root/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  props: [
    "players",
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    AppAdministratorTrainingsRootListFormCreateIndexVue,
    AppAdministratorTrainingsRootListFormUpdateIndexVue,
    AppAdministratorTrainingsRootListFormRemoveIndexVue,
  },
})
export default class AppAdministratorTrainingsRootListIndexVue extends Vue {
  isLoading: boolean | null = false;
  formData: any = {
    filter: {
      user_id: "*",
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };
  moment: any = null;

  players: Array<AppCommonUser> = [];
  trainingCategories: Array<AppCommonTrainingCategory> = [];

  trainings: Array<AppAdministratorTrainingsRootListIndex> = [];

  async getTrainings(formData: any = null): Promise<void> {
    this.isLoading = true;

    if (formData) {
      this.formData = formData;
    }

    await getRequest({
      uri: `/common/trainings`,
      formData: this.formData,
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.trainings = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    this.moment = moment;
    await this.getTrainings();
  }
}
